import React, { createContext, useCallback, useContext, useState } from 'react';
import GlobalAlert from './GlobalAlert';

interface GlobalAlertContextType {
  showAlert: (message: string) => void;
}

const GlobalAlertContext = createContext<GlobalAlertContextType>({
  showAlert: () => {
    throw new Error('showAlert called outside of GlobalAlertProvider');
  },
});

export const useGlobalAlert = () => useContext(GlobalAlertContext);

export const GlobalAlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const showAlert = useCallback((msg: string) => {
    setMessage(msg);
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setMessage('');
  }, []);

  return (
    <GlobalAlertContext.Provider value={{ showAlert }}>
      {children}
      <GlobalAlert isOpen={isOpen} message={message} onClose={handleClose} />
    </GlobalAlertContext.Provider>
  );
};
